import BaseService from './baseService';

class SubmissionCategories extends BaseService {
	async getSubmissionCategories(opts = {}) {
    this.endPoint = '/submission-category';
		return this.get(opts);
  }
  async createSubmissionCategories(payload){
    this.endPoint = '/submission-category';
    return await this.post(payload); 
  }
  async updateSubmissionCategories(id,payload,opts={}){
    this.endPoint = '/submission-category';
    return await this.putOne(id,payload,opts);
  }
  async deleteSubmissionCategories(id,opts={}){
    this.endPoint = '/submission-category';
    return await this.delete(id,opts);
  }
}

export default new SubmissionCategories();